if (!customElements.get('night-shift-product-cards')) {
  class NightShiftProductCards extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = null;
      this.slider = null;
      this.desktopQuery = window.matchMedia('(min-width: 1024px)');
      this.onBreakpointChange = this.onBreakpointChange.bind(this);
    }

    connectedCallback() {
      this.sliderElement = this.querySelector('[data-night-shift-product-cards-slider]');
      this.onBreakpointChange();

      if (this.desktopQuery.addEventListener) {
        this.desktopQuery.addEventListener('change', this.onBreakpointChange);
      } else {
        this.desktopQuery.addListener(this.onBreakpointChange);
      }
    }

    disconnectedCallback() {
      this.destroySlider();

      if (this.desktopQuery.removeEventListener) {
        this.desktopQuery.removeEventListener('change', this.onBreakpointChange);
      } else {
        this.desktopQuery.removeListener(this.onBreakpointChange);
      }
    }

    onBreakpointChange() {
      if (!this.sliderElement) return;

      if (this.desktopQuery.matches) {
        this.destroySlider();
        return;
      }

      this.initSlider();
    }

    initSlider() {
      if (this.slider || !window.Splide) return;

      this.slider = new window.Splide(this.sliderElement, {
        arrows: false,
        pagination: false,
        drag: true,
        gap: '16px',
        perPage: 1,
        autoWidth: true,
        trimSpace: false,
        padding: {
          left: '20px',
          right: '20px',
        },
      });

      this.slider.mount();
    }

    destroySlider() {
      if (!this.slider) return;

      this.slider.destroy(true);
      this.slider = null;
    }
  }

  customElements.define('night-shift-product-cards', NightShiftProductCards);
}
